import React from 'react';

function Footer() {
  const today = new Date();

  return <footer className="footer_auth">&copy; {today.getFullYear()} SellerGeni (P) Ltd, All Rights Reserved.</footer>;
}

export default Footer;
